var $22fbf25776bcbdd5$exports = {};
$22fbf25776bcbdd5$exports = {
    "backButton": (args)=>`Reveni\u{21B}i la ${args.prevMenuButton}`,
    "moreActions": `Mai multe ac\u{21B}iuni`,
    "unavailable": `Indisponibil, extinde\u{21B}i pentru detalii`
};


export {$22fbf25776bcbdd5$exports as default};
//# sourceMappingURL=ro-RO.module.js.map
